function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function parseLocalDate(dateInput) {
  if (!dateInput) return null;
  const str = String(dateInput);
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }
  const d = new Date(dateInput);
  return isNaN(d.getTime()) ? null : startOfDay(d);
}

function optionalFeeApplies(rowDate, lease, feeField, startField) {
  const fee = parseFloat(lease && lease[feeField] ? lease[feeField] : 0);
  if (!fee) return false;
  if (!lease[startField]) return true;
  const start = parseLocalDate(lease[startField]);
  if (!start) return true;
  const row = startOfDay(rowDate);
  return row.getTime() >= start.getTime();
}

function storageIsIncluded(lease) {
  const flag = lease && lease.hasStorage;
  return flag === true || flag === 1 || flag === '1';
}

function includedStorageApplies(rowDate, lease) {
  if (!storageIsIncluded(lease) || !lease.storageStart) return false;
  if (parseFloat(lease.storageFee || 0) !== 0) return false;
  const start = parseLocalDate(lease.storageStart);
  if (!start) return false;
  return startOfDay(rowDate).getTime() >= start.getTime();
}

function expectedRentParts(rowDate, lease) {
  const parts = [];
  if (optionalFeeApplies(rowDate, lease, 'parkingFee', 'parkingStart')) {
    parts.push('parking');
  }
  if (
    optionalFeeApplies(rowDate, lease, 'storageFee', 'storageStart') ||
    includedStorageApplies(rowDate, lease)
  ) {
    parts.push('storage');
  }
  if (optionalFeeApplies(rowDate, lease, 'mobileACRent', 'mobileACStart')) {
    parts.push('AC');
  }
  return parts;
}

function expectedRentLabel(rowDate, lease) {
  const parts = expectedRentParts(rowDate, lease);
  if (!parts.length) return 'Expected Rent';
  return `Expected Rent + ${parts.join(' + ')}`;
}

function expectedRentAmount(rowDate, lease) {
  let total = parseFloat((lease && lease.monthlyBaseRent) || 0);
  if (optionalFeeApplies(rowDate, lease, 'parkingFee', 'parkingStart')) {
    total += parseFloat(lease.parkingFee || 0);
  }
  if (optionalFeeApplies(rowDate, lease, 'storageFee', 'storageStart')) {
    total += parseFloat(lease.storageFee || 0);
  }
  if (optionalFeeApplies(rowDate, lease, 'mobileACRent', 'mobileACStart')) {
    total += parseFloat(lease.mobileACRent || 0);
  }
  return total;
}

function isExpectedRentDescription(description) {
  return (
    typeof description === 'string' &&
    description.startsWith('Expected Rent') &&
    !description.startsWith('Expected Prorat')
  );
}

module.exports = {
  optionalFeeApplies,
  expectedRentLabel,
  expectedRentAmount,
  isExpectedRentDescription,
};
